/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, August 21st 2022, 5:58:31 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder, Many2OneIntPKBaseSchema } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
  CONDITION_LOGIC_TYPES,
  TaskTemplate,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";

export interface NextActivation extends ProcessTemplateArtifact, WritableModel<false> {
  description?: string;
  condition_logic_type?: keyof typeof CONDITION_LOGIC_TYPES;
  task_definition: TaskTemplate["id"];
  ontrue: TaskTemplate["id"];
  readonly ontrue_task_definition_title?: TaskTemplate["title"];
  readonly conditions_count?: number;
  //   onfalse?: TaskTemplate["id"];
}

type WriteOnlyNextActivation = Omit<NextActivation, "id" | "ontrue_task_definition_title" | "conditions_count">;

export const NextActivationValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyNextActivation> =
  ProcessTemplateArtifactValidationSchema.shape({
    task_definition: Many2OneIntPKBaseSchema().required("Task Template is required."),
    ontrue: Many2OneIntPKBaseSchema()
      .required("The task template for the outgoing branch is required.")
      .typeError("Please provide a valid task template for the outgoing branch."),
    condition_logic_type: schemaBuilder.mixed().oneOf(Object.keys(CONDITION_LOGIC_TYPES)).optional(),
    description: schemaBuilder.string().optional(),
  });
